import ContentTitle from "components/common/ContentTitle";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  documentRequiredSlice,
  getDocumentRequired,
  getListSmartForm,
  submitSmartForm,
} from "redux/modules/visaForm";

export default function UploadDucumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, addSmartFormState, getSmartForm, smartform } =
    useSmartForm();

  const { showLoading, hideLoading } = useModalLoading();

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );
  const ConditionType = get(smartformDetail, "ConditionType.value", "");

  useEffect(() => {
    if (smartserviceId) {
      dispatch(
        getDocumentRequired({
          smartserviceId: "8ffa53f1-4e96-4c09-a13e-abc924dbff01",
          ConditionType,
        })
      );
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      showLoading();
    } else if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        dispatch(submitSmartForm({ draftId }));
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(getListSmartForm());
        dispatch(setSmartFormStep(SMART_T_STEP.NONE));
        dispatch(documentRequiredSlice.actions.clearAsyncState());
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, showLoading]);

  const getSubTitleByCondition = () => {
    switch (ConditionType) {
      case "CO":
        return "Update Job Position";
      case "AE":
        return "Add Job Position";
      case "AC":
        return "Add Company Investment";
      case "CA":
        return "Changing of company  address under the same juristic ID.";
      case "CN":
        return "Changing of company name under the same juristic ID.";
      case "DD":
        return "Divestment or decreasing shareholding.";
      default:
        return "";
    }
  };

  return (
    <div className={classes.root}>
      <ContentTitle
        subTitle="Smart Visa Qualifications Update Form"
        title={getSubTitleByCondition()}
      />
      <UploadDucument isExtension={false} />
    </div>
  );
}
